import { useContext } from "react";
import { NotificationFeedbackContext } from "../providers/NotificationFeedbackProvider";

const useNotificationFeedbackSettings = () => {
  const context = useContext(NotificationFeedbackContext);
  if (!context) {
    throw new Error(
      "useNotificationFeedbackSettings must be used within NotificationFeedbackProvider"
    );
  }
  return context;
};

export default useNotificationFeedbackSettings;
